

export const ADMINAUTH='AUTH';
export const ADMINLOGOUT='LOGOUT';